import React from "react";
import styled from "styled-components";

const ShadowBox = ({ children, ...props }) => {
    return (
        <Box {...props}>
            {children}
        </Box>
    );
};

const Box = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  border-radius: 10px;
  border: 1px solid var(--aia-bx-grey-20);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
  background-color: var(--aia-bx-gray-6);
  padding: 16px;
`;

export default ShadowBox;